import { BsArrowLeft } from "react-icons/bs";

import Tooltip from "../../../shared/components/tooltip/tooltip";
import "./editable-list-page.scss";
import { useBack } from "../../../shared/utils/use-back";
import { IDataUrl } from "../../utils";
import { IColumn } from "../data-table/data-table";
import EditableDataTable from "../editable-data-table/editable-data-table";

export interface IListPageConfig {
  title: string;
  columns: IColumn[];
  dataUrl: IDataUrl;
  postUrl: IDataUrl;
  titleTooltip?: string;
  defaultSortCol?: string;
  handleDataChange?: (isDirty: boolean) => void;
  forceSave?: boolean;
  setForceSave?: (value: boolean) => void;
}

const EditableListPage = ({
  columns,
  title,
  titleTooltip,
  dataUrl,
  postUrl,
  defaultSortCol,
  handleDataChange,
  forceSave,
  setForceSave
}: IListPageConfig) => {
  const { handleBack } = useBack();

  return (
    <div className="editableListPage">
      <div onClick={() => handleBack()} className="editableListPage-navButton">
        <BsArrowLeft />
      </div>

      <div className="editableListPage-header">
        <h1>
          {title}
          {titleTooltip && <Tooltip content={titleTooltip} direction="top" delay={350} />}
        </h1>
      </div>

      <EditableDataTable
        columns={columns}
        dataUrl={dataUrl}
        postUrl={postUrl}
        defaultSortCol={defaultSortCol}
        handleDataChange={(isDirty: boolean) => {
          handleDataChange?.(isDirty);
        }}
        forceSave={forceSave}
        setForceSave={setForceSave}
      />
    </div>
  );
};

export default EditableListPage;
